import { registerMessages } from "../../i18n/runtime";
import { frontdeskEn } from "./messages.en";
import { frontdeskEs } from "./messages.es";

registerMessages("en", frontdeskEn);
registerMessages("es", frontdeskEs);
